/**
     *  SHORTLIST FUNCTIONALITY START
     */

    // Get course and cookie details
    var cisguid = jQuery("#cisguid").val();
    if (cisguid != null && cisguid != "")
        cisguid = cisguid.replace(/\s/g, '');

    var cookieValString = jQuery.cookie("cids");
    // Tidy up cookie val string
    cookieValString = TidyCookieValString(cookieValString);

    var cookieVal = cookieValString != null && cookieValString != "" ? cookieValString.split(',') : "";
    var cookieLength = cookieValString == null || cookieValString == "" ? 0 : cookieValString.split(',').length;

    // Update the shortlist count icon
    UpdateShortlistCountAndIcon(cookieLength);

    // Update the Add to Shortlist button (course page) if already on shortlist
    if (jQuery("a#add-shortlist-button").length > 0 && cisguid != null && cisguid != "") {
        UpdateAddToShortlistButton(jQuery.inArray(cisguid, cookieVal) != -1);
    }

    updateShortlistFn = function() {
        var listcisguid = jQuery(this).data("guid");

        if (listcisguid != "" && listcisguid != undefined) {

            if (jQuery.inArray(listcisguid, cookieVal) == -1) {

                // Update the Add to Shortlist Button  text
                UpdateAddToShortlistListButton(false, jQuery(this));

            } else {

                // Update the Add to Shortlist Button  text
                UpdateAddToShortlistListButton(true, jQuery(this));
            }
        }
        return;
    }

    // loop through list and update text and icon accordingly for shortlist
    jQuery('.shortlist').each(updateShortlistFn);

    shortlistClickFn = function(e) {
       e.preventDefault();

        // get guid from the element that was clicked
        cisguid = jQuery(this).data("guid");
        //console.log('cisguid: ' + cisguid);
        if (cisguid != "") {

            if (jQuery.inArray(cisguid, cookieVal) == -1) {

                // NOt yet in the cookie, so let's add it
                if (cookieVal == "")
                    cookieVal += cisguid;
                else
                    cookieVal += "," + cisguid;
                //console.log('cisguid: ' + cisguid);
                cookieValString = cookieVal;

                // Update the Add to Shortlist Button  text
                UpdateAddToShortlistListButton(true, jQuery(this));

            } else {

                var counter = cookieValString.split(',').length;

				var htmlAttrText = jQuery(this).attr('title');

				if(htmlAttrText != "Add to shortlist")
				{

					if (counter == 1) {
						// Already in the cookie, so let's remove it
						cookieValString = cookieValString.replace(cisguid, "");
					}
					else {
						var firstitem = cookieValString.split(',')[0];

						if (firstitem == cisguid)
							cookieValString = cookieValString.replace(cisguid + ",", "");
						else
							cookieValString = cookieValString.replace("," + cisguid, "");
					}

					// Update the Add to Shortlist Button  text
					UpdateAddToShortlistListButton(false, jQuery(this));
				}
            }


            // Update cookie val and shortlist icon
            UpdateCookieValueAndShortlistCountIcon(cookieValString);
        }

        return;
    }

    jQuery("a.shortlist").click(shortlistClickFn);

    // remove item from shortlist page
    jQuery("a.shortlistremove").click(function (e) {
        e.preventDefault();

        // get guid from the element that was clicked
        cisguid = jQuery(this).data("guid");
        //console.log('cisguid: ' + cisguid);
        if (cisguid != "") {

            // check if the item is in the cookie list
            if (jQuery.inArray(cisguid, cookieVal) != -1) {

                var counter = cookieValString.split(',').length;

                if (counter == 1) {
                    // Already in the cookie, so let's remove it
                    cookieValString = cookieValString.replace(cisguid, "");
                    jQuery(".noShortList").show();
                    jQuery(".courses-list .heading").hide();
                }
                else {
                    var firstitem = cookieValString.split(',')[0];

                    if (firstitem == cisguid)
                        cookieValString = cookieValString.replace(cisguid + ",", "");
                    else
                        cookieValString = cookieValString.replace("," + cisguid, "");
                }

                // remove li
                jQuery(this).parent().remove();

            }

            // Update cookie val and shortlist icon
            UpdateCookieValueAndShortlistCountIcon(cookieValString);
        }

        return;
    });

    jQuery("a#add-shortlist-button").click(function (e) {

        e.preventDefault();

        // Get latest cookie details
        cookieValString = jQuery.cookie("cids");
        cookieVal = cookieValString != null ? cookieValString.split(',') : "";
        var cookieLength;

        if (cisguid != "") {

            if (jQuery.inArray(cisguid, cookieVal) == -1) {

                // NOt yet in the cookie, so let's add it
                if (cookieVal == "")
                    cookieVal += cisguid;
                else
                    cookieVal += "," + cisguid;

                cookieValString = cookieVal;

                // Update the Add to Shortlist Button  text
                UpdateAddToShortlistButton(true);

            } else {

                var counter = cookieValString.split(',').length;

                if (counter == 1) {
                    // Already in the cookie, so let's remove it
                    cookieValString = cookieValString.replace(cisguid, "");
                }
                else {
                    var firstitem = cookieValString.split(',')[0];

                    if (firstitem == cisguid)
                        cookieValString = cookieValString.replace(cisguid + ",", "");
                    else
                        cookieValString = cookieValString.replace("," + cisguid, "");
                }

                // Update the Add to Shortlist Button  text
                UpdateAddToShortlistButton(false);
            }

            // Update cookie val and shortlist icon
            UpdateCookieValueAndShortlistCountIcon(cookieValString);
        }
    });

    function UpdateCookieValueAndShortlistCountIcon(cookieValString) {

        //if (cookieValString == null || cookieValString == "")
        //    return;

        if (cookieValString != "")
            cookieValString = TidyCookieValString(cookieValString);

        // Update the shortlist count icon
        cookieVal = cookieValString != null && cookieValString != "" ? cookieValString.split(',') : "";
        cookieLength = cookieValString == "" ? 0 : cookieValString.split(',').length;

        UpdateShortlistCountAndIcon(cookieLength);

        // update cookie value
        jQuery.cookie("cids", cookieValString, { expires: 7, path: "/", secure: true });

        //console.log('cookie val: ' + cookieValString);

        return;
    }

    function UpdateAddToShortlistButton(onShortlist) {
        var htmlOld = jQuery("a#add-shortlist-button").html();
        var htmlOldText = jQuery("a#add-shortlist-button").text();

        var htmlNew = onShortlist
            ? htmlOld.replace(htmlOldText, "Remove from shortlist")
            : htmlOld.replace(htmlOldText, "Add to shortlist");

        jQuery("a#add-shortlist-button").html(htmlNew);

        var courseName = jQuery(".heading.long-heading").text().trim();

        if (onShortlist) {
            //jQuery("a#add-shortlist-button").attr('title', 'Remove from shortlist');
            jQuery("a#add-shortlist-button").children('i').removeClass("icon-star");
            jQuery("a#add-shortlist-button").children('i').addClass("icon-remove");
        }
        else {
            //jQuery("a#add-shortlist-button").attr('title', 'Add to shortlist');
            jQuery("a#add-shortlist-button").children('i').removeClass("icon-remove");
            jQuery("a#add-shortlist-button").children('i').addClass("icon-star");
        }

        return;
    }

    function UpdateAddToShortlistListButton(onShortlist, element) {
        var htmlOld = element.html();
        var htmlOldText = element.text();

        var courseName = jQuery(element).prev('a').text().trim();
        var htmlNew = onShortlist
            ? htmlOld.replace(htmlOldText, "Remove "+courseName+" from shortlist")
            : htmlOld.replace(htmlOldText, "Add "+courseName+" to shortlist");

        element.html(htmlNew);

        if (onShortlist) {
            //element.attr('title', 'Remove '+courseName+' from shortlist');
            element.children('i').removeClass("icon-star");
            element.children('i').addClass("icon-remove");
        }
        else {
            //element.attr('title', 'Add  '+courseName+' to shortlist');
            element.children('i').removeClass("icon-remove");
            element.children('i').addClass("icon-star");
        }

        return;
    }

    function UpdateShortlistCountAndIcon(count) {

        // testing: count += 98;

        if (count > 0) {
            jQuery("i.icon-shortlist").addClass("has-items");
            jQuery(".shortlist-count-container").show();
            jQuery("li.shortlist .shortlist-count").show();
            jQuery(".noShortList").hide();
        } else {
            jQuery("i.icon-shortlist").removeClass("has-items");
            jQuery(".shortlist-count-container").hide();
            jQuery("li.shortlist .shortlist-count").hide();
            jQuery(".noShortList").show();
        }

        if (count > 99)
            count = "99+";

        jQuery("#shortlist-count-icon").text(count);
        jQuery("#shortlistpage-count-icon").text(count);

        return;
    }

    function TidyCookieValString(cookieValString) {
        //console.log('cookieValString before: ' + cookieValString);
        if (cookieValString == null || cookieValString == "")
            return;

        // delete all undefined record
        cookieValString = cookieValString.replace(/\undefined,/g, '');

        /*
        if (cookieValString.startsWith(',') || cookieValString.startsWith('%2C'))
            cookieValString = cookieValString.substring(1);
        if (cookieValString.endsWith(',') || cookieValString.endsWith('%2C'))
            cookieValString = cookieValString.substring(0, cookieValString.length - 1);
        cookieValString = cookieValString.replace(',,', ',').replace('%2C%2C', '%2C');
        */
        //console.log('cookieValString after: ' + cookieValString);
        return cookieValString.trim();
    }
